var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermissionPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 100",
    d: "M18.6344 9C18.6344 13.8332 14.7289 17.75 9.91293 17.75C5.09691 17.75 1.19141 13.8332 1.19141 9C1.19141 4.16676 5.09691 0.25 9.91293 0.25C14.7289 0.25 18.6344 4.16676 18.6344 9Z",
    fill: "#8D70FE",
    fillOpacity: 0.2,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Orange"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 38764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 120",
    d: "M5.74826 12.9614L4.66146 7.86647C4.64453 7.78707 4.72426 7.72165 4.79882 7.75377L7.80041 9.04666C7.84886 9.06753 7.90519 9.04718 7.9291 9.00016L9.90198 5.12166C9.93769 5.05146 10.0368 5.04817 10.077 5.11584L12.3916 9.00338C12.4185 9.04862 12.4759 9.06523 12.5229 9.04135L15.0227 7.76972C15.0968 7.73203 15.1819 7.79596 15.1663 7.87762L14.1951 12.9593C14.1861 13.0064 14.1449 13.0405 14.0969 13.0405H5.84606C5.79887 13.0405 5.7581 13.0075 5.74826 12.9614Z",
    fill: "#BAA8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 121",
    d: "M5.74826 12.9609L4.66157 7.86651C4.64461 7.78702 4.72455 7.72158 4.79913 7.7539L7.12381 8.76113C7.15333 8.77392 7.17489 8.80012 7.18175 8.83155L8.07448 12.9187C8.0881 12.9811 8.04061 13.04 7.97679 13.04H5.84606C5.79887 13.04 5.7581 13.0071 5.74826 12.9609Z",
    fill: "#DFD7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 122",
    d: "M5.21587 10.5773L4.65927 7.86295C4.6431 7.78408 4.72201 7.71941 4.79617 7.75075L5.90718 8.22032C5.93696 8.23291 5.95882 8.25912 5.96585 8.29069L6.46595 10.5355C6.47986 10.5979 6.43234 10.6572 6.36834 10.6572H5.31383C5.26635 10.6572 5.22541 10.6238 5.21587 10.5773Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 120_2",
    d: "M5.74826 12.9614L4.66146 7.86647C4.64453 7.78707 4.72426 7.72165 4.79882 7.75377L7.80041 9.04666C7.84886 9.06753 7.90519 9.04718 7.9291 9.00016L9.90198 5.12166C9.93769 5.05146 10.0368 5.04817 10.077 5.11584L12.3916 9.00338C12.4185 9.04862 12.4759 9.06523 12.5229 9.04135L15.0227 7.76972C15.0968 7.73203 15.1819 7.79596 15.1663 7.87762L14.1951 12.9593C14.1861 13.0064 14.1449 13.0405 14.0969 13.0405H5.84606C5.79887 13.0405 5.7581 13.0075 5.74826 12.9614Z",
    stroke: "black",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionPurple);
export default __webpack_public_path__ + "static/media/permissionPurple.4be42502d2f9f8b8c62fac9e61e34545.svg";
export { ForwardRef as ReactComponent };